<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <rect x="3" y="3" width="8" height="8" rx="1.5" stroke="currentColor" stroke-width="1.75" />
  <rect x="13" y="3" width="8" height="8" rx="1.5" stroke="currentColor" stroke-width="1.75" />
  <rect x="3" y="13" width="8" height="8" rx="1.5" stroke="currentColor" stroke-width="1.75" />
  <rect x="13" y="13" width="8" height="8" rx="1.5" stroke="currentColor" stroke-width="1.75" />
</svg>
